import { render, staticRenderFns } from "./purchaseGuide.vue?vue&type=template&id=9b304bd6&scoped=true"
import script from "./purchaseGuide.vue?vue&type=script&lang=js"
export * from "./purchaseGuide.vue?vue&type=script&lang=js"
import style0 from "./purchaseGuide.vue?vue&type=style&index=0&id=9b304bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b304bd6",
  null
  
)

export default component.exports